import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CardLayoutComponent } from '../shared/card-layout/card-layout.component'
import { CookieDisabledPageComponent } from './cookie-disabled-page/cookie-disabled-page.component'
import { GenericErrorPageComponent } from './generic-error-page/generic-error-page.component'
import { NetworkErrorPageComponent } from './network-error-page/network-error-page.component'
import { Page404Component } from './page404/page404.component'
import { SessionExpiredPageComponent } from './session-expired-page/session-expired-page.component'
import { CookieDisabledGuard } from './shared/cookie-disabled.guard'

const routes: Routes = [
  {
    path: 'feedback',
    component: CardLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '404',
        pathMatch: 'full',
      },
      {
        path: 'no-cookies',
        component: CookieDisabledPageComponent,
        canActivate: [CookieDisabledGuard],
      },
      {
        path: 'network-error',
        component: NetworkErrorPageComponent,
      },
      {
        path: 'generic-error',
        component: GenericErrorPageComponent,
      },
      {
        path: 'session-expired',
        component: SessionExpiredPageComponent,
      },
      { path: '404', component: Page404Component },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeedbackRoutingModule {}
